import React from 'react';

interface ActivityHeaderEditorProps {
  title: string;
  description: string;
  activityType?: string;
  onTitleChange: (title: string) => void;
  onDescriptionChange: (description: string) => void;
  titlePlaceholder?: string;
  descriptionPlaceholder?: string;
  className?: string;
}

const ActivityHeaderEditor: React.FC<ActivityHeaderEditorProps> = ({
  title,
  description,
  activityType,
  onTitleChange,
  onDescriptionChange,
  titlePlaceholder = "Activity Title",
  descriptionPlaceholder = "Activity Description",
  className = "",
}) => {
  return (
    <div className={`bg-white p-6 rounded-lg border border-gray-200 shadow-sm ${className}`}>
      {activityType && (
        <div className="mb-4">
          <span className="inline-block px-2 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full">
            {activityType}
          </span>
        </div>
      )}
      <input
        type="text"
        className="w-full text-xl font-bold mb-2 border-b border-gray-200 pb-2 focus:outline-none focus:border-blue-500"
        value={title}
        onChange={(e) => onTitleChange(e.target.value)}
        placeholder={titlePlaceholder}
      />
      <textarea
        className="w-full text-gray-700 border-none focus:outline-none focus:ring-0 resize-none"
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        placeholder={descriptionPlaceholder}
        rows={2}
      />
    </div>
  );
};

export default ActivityHeaderEditor; 